"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareErc998TemplatesInitialValues = exports.erc998TemplatesEditFilter = exports.erc998TemplatesCreateFilter = void 0;
const exchange_1 = require("@framework/exchange");
const types_1 = require("../../../../types");
const erc998TemplatesCreateFilter = ({ title, description, price, amount, imageUrl, contractId, }) => ({
    title,
    description,
    amount,
    imageUrl,
    contractId,
    price: (0, exchange_1.cleanUpAsset)(price),
});
exports.erc998TemplatesCreateFilter = erc998TemplatesCreateFilter;
const erc998TemplatesEditFilter = ({ title, description, price, amount, imageUrl, templateStatus, }) => ({
    title,
    description,
    amount,
    imageUrl,
    templateStatus,
    price: (0, exchange_1.cleanUpAsset)(price),
});
exports.erc998TemplatesEditFilter = erc998TemplatesEditFilter;
const prepareErc998TemplatesInitialValues = (service, merchantId) => ({ id, title, description, price, amount, templateStatus, contractId, imageUrl }) => {
    return {
        id,
        title,
        description,
        price,
        amount,
        templateStatus,
        contractId,
        imageUrl,
        // this is only filter for contract autocomplete
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareErc998TemplatesInitialValues = prepareErc998TemplatesInitialValues;
//# sourceMappingURL=schemas.js.map